export default __webpack_public_path__ + "maps-examples-select-layer-thumbnail-960-d7a95d50839904ecbb8dc2be63f3106e.webp";